<template>
  <div class="fixed-top shadow-sm">
    <header class="header-nav py-2">
      <div class="row flex-nowrap justify-content-between align-items-center">
        <div class="brand">
          <a href="https://discoverlaos.today/" target="_blank">
            <img src="@/assets/logo_white.png" alt="" class="logo-center"
          /></a>
        </div>
        <div class="float-left pt-1 ml-1"> 
          <span @click="backButton()"  v-if="headerleft == false">
            <base-icon icon_name="arrow-left"  />
            <a class="header-nav-title" href="#" >{{ title }}</a>
          </span>
          <slot name="header-left" v-if="headerleft == true"></slot>
          
        </div>

        <div class="float-right d-flex justify-content-end align-items-center">
          <base-icon
            v-if="user"
            icon_name="home"
            class="ml-2 mr-2 pointer"
            @click.native="home()"
          />
          <div class="ml-2 mr-2" @click="pending()">
            <base-icon icon_name="bell"></base-icon>
            <span class="badge badge-warning number-notify" v-if="number > 0">{{
              number
            }}</span>
          </div>

          <slot name="icon-more"></slot>

          <base-icon
            icon_name="sidebar"
            class="ml-2 mr-2 pointer"
            @click.native="showMenu()"
          /> 
        </div>
      </div>
    </header>
    <slot></slot>
  </div>
</template>
<script>
import store from "@/store";
import redirectLogin from '@/helper/redirect';
export default {
  name: "HeaderApp",
  props: {
    title: {
      type: String,
      default: "Title",
    },
    to: {
      type: String,
      default: "province",
    },
    param: {
      type: Object,
    },
    headerleft: {
      type: Boolean,
    },
  },
  computed: {
    number() {
      return store.getters["nav/pending_number"];
    },
    user() {
      return store.getters["auth/user"];
    },
  },
  methods: {
    pending() {
      this.$router.push({ name: "orders" }).catch((err) => {});
    },
    showMenu() {
      this.$store.dispatch("nav/nav_menu");
    },
    backButton() { 
      this.$router
        .push({ name: this.to, params: this.param })
        .catch((err) => {});
    },
    home() {
      this.$router.push({ name: "province" }).catch((err) => {});
    },
    async login() { 
      window.location.href = redirectLogin;
    },
    async logout() {
      await store.dispatch("auth/LogOut");
      this.$router.push({ name: "province" }).catch((err) => {});
    },
  },
};
</script>
<style lang="scss">
.number-notify {
  position: absolute;
  margin-left: -12px;
  margin-top: -7px;
}
.brand {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: block;
}
.logo-center {
  width: 50px;
  margin-top: 5px;
}
</style>